import createSlider from "./modules/heroSlider";
import newProductSlider from "./modules/newProduct";


window.addEventListener('DOMContentLoaded', (event) => {
    const sliderHero = createSlider('.js-slider-hero');
    const slidernew = newProductSlider('.js-slider-newProduct');
});
